module.exports = __webpack_public_path__ + "img/trash.1fe7dc43.svg";